import {
  Button,
  ColorClass,
  Icon,
  IconIdentifier,
} from '@aus-platform/design-system';
import React from 'react';
import { useAppDispatch } from 'src/app/hooks';
import { setActiveSidebarOption } from 'src/map-3d/shared/map-3d-slices';
import { map3dSidebarItems } from '../../../../constants';
import { CrossSectionErrorMessage, Map3DSidebarOption } from '../../../../shared';

export const CrossSectionNoPointCloud: React.FC = () => {
  // Hooks.
  const dispatch = useAppDispatch();

  const handleOpenWorkspace = () => {
    const workspaceItem =
      map3dSidebarItems.find(
        (item) => item.cardProps.title === Map3DSidebarOption.Workspace,
      ) ?? map3dSidebarItems[0];

    dispatch(setActiveSidebarOption(workspaceItem));
  };

  return (
    <div className="cross-section-no-point-cloud">
      <Icon
        className="cross-section-no-point-cloud__icon"
        size={78}
        identifier={IconIdentifier.PointCloud}
        colorClass={ColorClass.Primary500}
      />
      <span className="cross-section-no-point-cloud__title">
        No point cloud layer in workspace
      </span>
      <span className="cross-section-no-point-cloud__error">
        {CrossSectionErrorMessage.NoPointCloudLayer}
      </span>
      <Button onClick={handleOpenWorkspace}>Open Workspace</Button>
    </div>
  );
};
